import { bootstrapApplication } from '@angular/platform-browser';
import * as Sentry from "@sentry/angular";

import { appConfig } from './app/app.config';
import { AppComponent } from './app/app.component';
import { environment } from './environments/environment';

Sentry.init({
  dsn: "https://bb95a7c15110c088cbae9f9ca8f8fd62@o4509015076241408.ingest.de.sentry.io/4509015083778128",
  environment: environment.production ? "production" : "development",
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ["log", "warn", "error"] }),
  ],
  tracesSampleRate: 1.0,
  tracePropagationTargets: ["localhost", /^https:\/\/staffit\.alwaysdata.net\/api/],
  enableLogs: true,
});

bootstrapApplication(AppComponent, appConfig)
  .catch((err) => console.error(err));
